import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StepperService {

  className = 'StepperService';
  private _subject: Subject<any>;
  stepChange: Observable<any>;

  constructor() {
    this._subject = new Subject<any>();
    this.stepChange = this._subject.asObservable()

  }

  changeStep(data) {
    this._subject.next(data);
  }
}
